/**
 * Scroll reveal for DROPIT, with no library.
 *
 *   [data-reveal]        one element rises and fades in when it scrolls into view
 *   [data-reveal-group]  a container: when it scrolls into view, its [data-reveal-item] children
 *                        rise one after another (stagger with style="--reveal-i: 0, 1, 2…")
 *
 * Performance rules:
 * - Only transform/opacity animate (GPU, no layout, no CLS).
 * - Anything already on screen at load is revealed at once without animation, so the hero and the
 *   LCP image are never hidden.
 * - Hiding only starts after this module runs (html.dropit-reveal-ready). Without JS, or with
 *   reduced motion, everything is simply visible.
 */
const root = document.documentElement;
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduced && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
  const targets = Array.from(document.querySelectorAll('[data-reveal], [data-reveal-group]'));
  const fold = window.innerHeight;

  const reveal = (el) => el.setAttribute('data-revealed', '');

  // Above the fold: show now, no animation
  for (const el of targets) {
    if (el.getBoundingClientRect().top < fold) reveal(el);
  }

  root.classList.add('dropit-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const el of targets) {
    if (!el.hasAttribute('data-revealed')) observer.observe(el);
  }
}
